import { RemoteWork } from '@/javascript/data/entities/remote-work'

export enum RemoteRoutePointType {
  origin = 0,
  waypoint = 1,
  destination = 2,
}

export type RemoteRoutePoint = {
  id: number
  created_at: string
  updated_at: string
  routing_member_id: number
  work_id?: number
  sequence: number
  point_type: RemoteRoutePointType
  arrival_time: string
  departure_time: string
  location_address: string
  location_lat: string
  location_lng: string
  work?: RemoteWork
}
